import { Injectable } from '@angular/core';
import { ApiClass } from "@data/class/api-class";
import { IResponseArray } from "@data/interfaces/iresponseArray.interface";
import { environment } from "@env/environment";
import { catchError, map, of } from "rxjs";
import { IProviderList } from "@modules/private/provider/data/interfaces/iprovider.interface";

@Injectable({
  providedIn: 'root'
})
export class ApiProviderService extends ApiClass {
  constructor() {
    super()
    this.path = 'providers'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: IProviderList = { error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0 }
    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
      map((r) => r as IProviderList),
      catchError((e) => of(response))
    )
  }

  create(data: any) {
    return this.postCollection(data, 'create').pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  getById(id: string) {
    return this.getCollection(id).pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  update(id: string, data: any) {
    return this.putCollection(data, undefined, 'providers/' + id).pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  getAssetsFromProvider(id: string) {
    const response: IProviderList = { error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0 }
    const filters = { provider: { value: id, matchMode: 'equals' } }
    return this.http.post<IResponseArray>(environment.apiUrl + 'assets', { page: 1, limit: 1000, filters }).pipe(
      map((r) => r as any),
      catchError((e) => of(response))
    )
  }
}
